import { GmailIcon } from "../assets/icon/GmailIcon";
import { LinkedinIcon } from "../assets/icon/linkedinIcon";
import { forwardRef } from "react";

export const ContactSheet = forwardRef(({showContact} , ref) =>{      

  return(
        <>
            <div ref={ref} className={`w-full min-[420px]:w-fit  min-[420px]:max-w-[75vw] h-[50vh] min-h-fit min-[420px]:h-[100vh] px-12 fixed top-0 left-0 z-10 bg-[var(--backgrd)] shadow-xl flex items-center justify-center ${showContact ? 'translate-y-[100%] translate-x-[0] min-[420px]:translate-x-[0] min-[420px]:translate-y-[0]' :'translate-y-[200%] translate-x-[0] min-[420px]:-translate-x-[100%] min-[420px]:translate-y-[0]'} transition-all duration-500 ease-in-out`}>
                  <ul className=" text-center">
                      <li>
                          <small className=" capitalize font-medium tracking-widest text-[var(--text)]">
                              our contacts
                          </small>
                      </li>
                      <li className="text-[var(--text-m)] my-4 me-4 tracking-wide inline-block">
                          09081885935
                      </li>
                      <li className="text-[var(--text-m)] tracking-wide inline-block">
                          09138435908
                      </li>
                      <li className="flex flex-wrap justify-center items-center gap-4 my-4">
                          <GmailIcon /> 
                          <LinkedinIcon />                        
                      </li>
                      <li>
                          <small className="text-[var(--text-m)]">
                              We are a fully remote company incorporated in Nigeria
                          </small>
                      </li>
                  </ul>
            </div>
        </>
  )
})